import './AboutSite.css';

function AboutSite() {
    return (
        <div className="info-container">
            <h1>ברוכים הבאים ל-JustRentIt!<br />המקום להשכיר שמלה חלומית לכל אירוע.</h1>

            <p>
                JustRentIt מציעה פלטפורמה נגישה ונוחה להשכרת שמלות מדהימות, שתאפשר לך למצוא את השמלה המושלמת עבורך.
            </p>

            <h2>איך זה עובד?</h2>

            <h3>העלאת שמלה:</h3>
            <p>
                מעוניינת להשכיר את השמלה שלך? פשוט העלי תמונה, פרטים ומידע רלוונטי לאתר.
                <br />
                לאחר העלאת השמלה, תקבלי מאיתנו מייל עם תנאי השימוש באתר, הכוללים תשלום עמלה של 15% ממחיר השמלה במקרה של השכרה דרך האתר.
                <br />
                לאחר אישור תנאי השימוש, השמלה שלך תעלה לאתר, ותקבלי מייל אישור עם קישור לשמלה.
            </p>

            <h3>התעניינות בשמלה:</h3>
            <p>
                לקוח שמתעניין בשמלה שלך ייצור איתנו קשר.
                <br />
                אנו נעביר את פרטיך ללקוח, ונוודא שהוא מעדכן אותנו לגבי מצב ההשכרה.
                <br />
                בנוסף, אנו ניידע אותך על התעניינות בשמלה שלך, ונעדכן אותך לגבי המשך התהליך.
            </p>

            <h3>השכרה מוצלחת:</h3>
            <p>
                במקרה של השכרה מוצלחת דרך האתר, נבקש ממך תשלום עמלה של 15% ממחיר ההשכרה.
            </p>

            <h2>למה לבחור ב-JustRentIt?</h2>

            <ul>
                <li><strong>פלטפורמה חינמית:</strong> העלאת שמלות לאתר היא בחינם.</li>
                <li><strong>קהל יעד רחב:</strong> חשיפה לקהל לקוחות גדול ומגוון.</li>
                <li><strong>שירות אישי:</strong> אנו כאן כדי לסייע לך בכל שלב בתהליך.</li>
            </ul>

            <p>
                אנו מאמינים בשיתוף פעולה הוגן ופשוט, ולכן יצרנו תהליך שקוף ונגיש לכולם.
            </p>

            <p>
                הצטרפי עוד היום ל-JustRentIt, ותני לשמלה שלך הזדמנות לשמח אישה נוספת!
            </p>

            <div className="contact-info">
                <h2>צרו קשר</h2>
                <p>
                    מייל: <a href="mailto:just.rent.it1@gmail.com">just.rent.it1@gmail.com</a>
                </p>
            </div>
        </div>
    );
}

export default AboutSite;